export enum ConsumptionAggregateType {
  CURRENT = 'CURRENT',
  DAY = 'DAY',
  MONTH = 'MONTH',
}
